export enum EnumWordType {
  Search,
  Comapny,
  Human,
  Topic,
  Article,
  New = 10,
}

export enum EnumTagType {
  New = 1,
  Hot,
  Up,
  Down,
}

/** @description 品牌-1/机构-2/集团-3/族群-4 */
export enum EnumBrandCardType {
  Brand = 1,
  Organize,
  Group,
  EthnicGroup,
}

export enum EnumCardTypeText {
  Brand = '品牌',
  Organize = '机构',
  Group = '集团',
  EthnicGroup = '族群',
}

/** @description 标识humanOrBrandBox容器内的元素卡片类型 */
export enum EnumHumanRoleType {
  /** @name 相关老板 */
  RelativeHuman,
  /** @name 同名老板 */
  SameNameHuman,
  /** @name 品牌/机构/集团/族群 */
  BrandGroup,
}

/** @description 标识产品类型 */
export enum EnumProdutionType {
  /** @name 企服商品 */
  QiFuProdution = 1,
  /** @name 产品服务 */
  ProductionService,
}

export interface HotTopicItemType {
  /** @name 评论数量，单位条 */
  answerNum: number;
  approval: boolean;
  aroundStatistics: number;
  aroundUserLogoList: string[];
  /** @name 话题内容 */
  content: string;
  createTime: number;
  discussType: number;
  focus: boolean;
  /** @name 话题ID */
  id: string;
  /** @name 标识是否热门，1-是，0-否 */
  isHot: number;
  isShowSupportStatistics: boolean;
  targetType: number;
  top: boolean;
  userShowType: number;
}

export interface ClaimCompanyItemType {
  alias: string;
  claimPkgType: number;
  detailLevel: number | string;
  id: number | string;
  isShow: boolean;
  logo: string;
  name: string;
  ownId: string;
  [propName: string]: any;
}

export interface HotRecommandItemType {
  companyId: number;
  companyName: string;
  url: string;
  [propName: string]: any;
}

export interface OfficeItemType {
  /** @name 公司所在城市 */
  area: string;

  /** @name 公司总数 */
  total: number;

  /** @name 公司名称 */
  companyName: string;
  cid: number;
  [propName: string]: any;
}
export interface HumanCardItemType {
  /** @name 老板姓名 */
  name: string;
  /** @name 搜索的姓名对应的ID */
  hid: number;
  /** @name 头像url */
  headUrl: string;
  /** @name 相关老板简介 */
  introduction: string;
  /** @name 老板身份认证状态，1-认证通过，0-认证中，-1-未认证 */
  bossCertificate: number;
  /** @name 任职公司数量 */
  companyNum: number;
  /** @name 具体任职公司 */
  office: OfficeItemType[];
  companys?: any[];
  partnerNum: number;
  partners?: any[];
  /** @name 搜索结果中的具体某个人ID */
  cid: number;
  alias?: string;
  /** @name 任职情况，1-在职，0-曾任职 */
  serviceType: number;
  /** @name 相关老板角色 */
  role: string;
  companyName?: string;
  /** @name  相关老板职位 */
  position?: string;
  [propName: string]: any;
}

interface ControllerListItem {
  handelName: string;
  handelNameId: string | number;
  handelNameGroupId: string | number;
  handelNameType: string | number;
  [propName: string]: any;
}

export interface BrandCardItemType {
  /** @name 机构类型 */
  type: string;
  id: string | number;
  /** @name 成员数量，单位1 */
  memberCount: number;
  /** @name 公司logo */
  logo: string;
  /** @name 公司名称 */
  name: string;
  alias: string;
  /** @name 融资次数 */
  roundCount: number;
  /** @name 当前轮次 */
  round: number;
  /** @name 投资事件次数 */
  eventCount: number;
  /** @name 管理基金 */
  fundCount: number;
  /** @name 对外投资 */
  investCount: number;
  actualControllerList: ControllerListItem[];
  [propName: string]: any;
}

/** @description 1-公司、2-推荐词、3-舆情新闻、4-企服商品、5-大家关注的公司、6-短视频、7-推广位卡片、8-品牌/机构/集团/族群 */
export enum EnumContentType {
  /** @name 公司 */
  COMPANY = 1,

  /** @name 推荐词 */
  SUGGEST_WORD = 2,

  /** @name 舆情新闻 */
  SENTIMENT_NEWS = 3,

  /** @name 企服商品 */
  QIFU_GOODS = 4,

  /** @name 大家关注的公司 */
  FOCUS_COMPANY = 5,

  /** @name 推广位卡片 */
  PROMOTION_CARD = 7,

  /** @name 品牌/机构/集团/族群 */
  BRAND_GROUP = 8,

  /** @name 发需卡片 */
  DEMAND_CARD = 9,
}

// 筛选类型标识
export enum filterFlag {
  AREA = 'base',
  CITY = 'city',
  DISTRICT = 'areaCode',
  REG_CAPITIAL = 'r', // 注册资本
  ESTIBLISH_TIME = 'e', // 成立时间
  CATE = 'c', // 行业分类
  SEC_INDU = 'sec_indu', // 行业大类
  TER_INDU = 'ter_indu', // 行业
  COMPANY_TYPE = 'companyType', // 机构类型
  CAPITAL_TYPE = 't', // 资本类型
  ORG_TYPE = 'ot', // 企业类型
  STAFF_SIZE = 'ss', // 参保人数
  REG_STATUS = 's', // 企业状态
  CONTACT_TYPE = 'ct', // 联系方式
  HAS_PHONE = 'hm', // 手机号码
  EMPTY_PHONE = 'kh', // 空号识别
  HAS_EMAIL = 'he', // 联系邮箱
  HAS_TM = 'ht', // 商标信息
  HAS_PATENT = 'ha', // 专利信息
  HAS_FINANCING = 'hf', // 融资信息
  HAS_BOND_TYPE = 'hb', // 上市状态
  IS_TAX_LEVEL = 'tl', // 税务评级
  IS_TAX_PAYER = 'tper', // 一般纳税人
  HAS_BID = 'bid', // 招投标
  HAS_DISHONEST = 'hd', // 失信信息
  WEBSITE = 'wb', // 网址信息
  HAS_MORTGAGE = 'mg', // 动产抵押
  TOP500 = 'tp', // TOP 500
  HAS_WORK_COPR = 'hw', // 作品著作权
  HAS_COPY_RIGHT = 'hc', // 软件著作权
  IS_HIGH_TECH_COMPANY = 'htc', // 高新技术企业
  LIST_SORT = 'la', // 列表排序方式
  // capitalType
}

export enum filterType {
  SIGNAL, // 单选
  DROPDOWN, // 下拉
}

export interface IFilterItem {
  isQuery?: boolean; // query参数
  flagStr?: string; // 链接中的标识
  paramsKey?: string; // 传参的字段名
  isVip?: boolean; // 是否需要VIP
  filterData?: any[]; // 筛选项options项
  filterTitle: string; // 筛选项名称
  showDescription?: IFilterDesc;
  childStr?: string; // 子类名称
  children?: IFilterItem[];
  type?: filterType; // 筛选项子类型
  childflagStr?: filterFlag;
  childParamsKey?: string;
  titleStr?: string;
  valStr?: string;
  [props: string]: any;
}
export interface ISelectedItem
  extends Pick<
  IFilterItem,
  | 'paramsKey'
  | 'filterTitle'
  | 'flagStr'
  | 'title'
  | 'isVip'
  | 'childflagStr'
  | 'childParamsKey'
  | 'titleStr'
  | 'valStr'
  > {
  val: string | number;
  start?: string | number | null;
  end?: string | number | null;
  name?: string;
  base?: string;
  areaCode?: string;
  [props: string]: any;
}

export interface IQueryParams {
  [props: string]: any;
}

interface ISubDescribeItem {
  icon: string;
  text: string;
}
interface ISubDescribe {
  title?: string;
  desc?: ISubDescribeItem[];
}
// 筛选项后面的描述文案
export interface IFilterDesc {
  name?: string;
  describe: string[];
  subDescribe?: ISubDescribe[];
}
export interface ProductionCardItem {
  /** @name 产品服务标题 */
  title: string;
  /** @name 类型，1-企服商品，2-产品服务 */
  type: number;
  /** @name 产品介绍 */
  introduce: string;
  /** @name 链接地址 */
  routeUrl: string;
  /** @name 产品服务图像 */
  imageUrl: string;
  /** @name 产品服务名称 */
  goodsName: string;
  originalImageUrl: string;
  /** @name 联系电话 */
  mobile: string;
  contentTitle: string;
}
export interface CooperateModalInfo {
  bigImageUrl: string;
  name: string;
  id: string | number;
  /** @name 产品服务标题 */
  title: string;
  /** @name 类型，1-企服商品，2-产品服务 */
  type: number;
  /** @name 产品介绍 */
  introduce: string;
  /** @name 链接地址 */
  routeUrl: string;
  /** @name 产品服务图像 */
  imageUrl: string;
  /** @name 产品服务名称 */
  goodsName: string;
  originalImageUrl: string;
  /** @name 联系电话 */
  mobile: string;
}

export enum AreaType {
  NotArea = 0, // 不是企业专区
  DefaultArea = 1, // 默认专区
  DefineArea = 2, // 自定义专区
}

export enum ClaimPkgType {
  Super = 2, // 超级认证
  Superme = 4, // 至尊认证
}

export enum AdsFlag {
  Advert = 1, // 广告
}

export enum ListModa {
  Normal = 0, // 正常展示
  Recommend = 1, // 看过这些公司的人还在看
}

// 用户状态
export enum UserStatus {
  NEED_LOGIN = 1, // 需要登录
  NEED_VIP, // 需要VIP
  NOT_NEED, // 不需要登录或VIP
}

// 公司类型
export enum EnumCompanyType {
  /** @name 公司 */
  Company = 1,

  /** @name 香港 */
  HongKong = 2,

  /** @name 社会组织 */
  Socail_Organize = 3,

  /** @name 律所 */
  Law_Firm = 4,

  /** @name 事业单位 */
  Institutions = 5,

  /** @name 基金会 */
  Foundation = 6,

  /** @name 台湾 */
  Taiwan = 8,

  /** @name 新增组织 */
  New_Organize = 9,
}

export interface IConfigItemProps {
  val?: string | number;
  start?: string | number | null;
  end?: string | number | null;
  name?: string;
  base?: string;
  areaCode?: string;
  categoryGuobiao2017?: string;
  secInduCode?: string;
  terInduCode?: string;
  [props: string]: any;
}

export interface IParsedUrlQuery {
  [props: string]: any;
  option?: any[];
}

export interface IUrlQueryKey {
  [props: string]: string;
}

export interface ICityMapItem {
  name: string;
  abbr: string;
  base: string;
  areaCode: string;
  value: string;
  briefName: string;
  prov?: boolean;
}

export interface ICityMapList {
  [prop: string]: ICityMapItem;
}
